import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArrowForward } from "@mui/icons-material";

const GetStartedSection = () => {
  return (
    <Container
      className="p-2 p-md-5 mt-4 hero-section"
    >
      <Row className="hero-content">
        <Col>
          <p className="text-center text-lg px-md-5" style={{lineHeight: '42px'}}>
            Why GAINSS is the AI-Native <br/>Solution Your Team Needs
          </p>
        </Col>
      </Row>
      <Row className="p-md-4 align-items-center hero-content">
        <Col>
          <h4 className="text-center" style={{fontSize: 16}}>AI at the Core of Every Feature</h4>
          <Container className="px-5">
            <Row>
              <Col>
              <p className="text-center p-md-5 pt-md-3 pb-0 text-std" style={{color: 'whitesmoke'}}>
            Unlike legacy test management tools that bolt on AI as an
            afterthought, GAINSS is designed from the ground up as an AI-native
            platform. Every feature leverages machine learning to make your
            testing smarter, faster, and more impactful.
          </p>
              </Col>
            </Row>
          </Container>
          
        </Col>
      </Row>
      <Row className="pb-4 mt-2 hero-content">
        <Col className="text-center">
          <p className="text-std">
            Discover how GAINSS turns testing into a strategic advantage with
            built-in AI
          </p>
          <a
            href="https://app.gainss.ai/register"
            style={{ background: "white" }}
            className="demo btn-rounded text-blue mt-4 mt-md-0 btn btn-primary"
          >
            Try For Free <ArrowForward />
          </a>
          {"  "}
        
          <a
            href="https://calendly.com/vikas-mittal"
            target="_blank"
            rel="noreferrer"
            style={{ borderColor: "white", color: "white", border: '1px solid', minHeight: '40px' }}
            className="new-btn btn btn-rounded btn-transaprent ml-md-4 mt-4 mt-md-0"
          >
            Get a Demo <ArrowForward />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default GetStartedSection;
